import { AnalysisAdditionalInfo } from "../../../../lib/enums";

export const getIsNotConfigured = (status?: string) =>
  status === AnalysisAdditionalInfo.NOT_CONFIGURED;
